import { ReactElement } from 'react';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { GoForwardButton } from '../../GoForwardButton';
import { ConfirmFormBase } from '../../shared/ConfirmFormBase';

export function ConfirmForm(): ReactElement {
  const { handleSubmit, navigateToProposta } = useHirePlanForm();

  return (
    <ConfirmFormBase onSubmit={handleSubmit(navigateToProposta)}>
      <h2 className="text-[2rem] font-semibold text-center text-primary-main">
        A inclus�o foi confirmada com sucesso!
      </h2>
      <GoForwardButton
        isMobile
        desktopText={'Ir para Proposta'}
        mobileText={'Ir para Proposta'}
        tipo="submit"
      />
    </ConfirmFormBase>
  );
}
